module.exports = __webpack_public_path__ + "images/help/icn-faq-problem@2x-b8e1989058b2ea1af38aac3718e2d470.png";